import React from 'react';

const GoogleIcon: React.FC = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.1 10.228C19.1 9.4125 19.0375 8.8375 18.9 8.2375H10V11.775H15.2C15.0875 12.6125 14.5 13.8625 13.325 14.725L13.3084 14.8656L16.1703 17.0647L16.36 17.0875C18.1 15.5 19.1 13.075 19.1 10.228Z" fill="#4285F4"/>
      <path d="M10 19.5C12.575 19.5 14.7 18.65 16.36 17.0875L13.325 14.725C12.525 15.2625 11.4375 15.65 10 15.65C7.5 15.65 5.375 14 4.525 11.7625L4.38714 11.7737L1.40776 14.0557L1.3625 14.1875C2.9875 17.375 6.2125 19.5 10 19.5Z" fill="#34A853"/>
      <path d="M4.525 11.7625C4.325 11.1625 4.2125 10.5125 4.2125 9.85C4.2125 9.1875 4.325 8.5375 4.5125 7.9375L4.5055 7.789L1.4917 5.47279L1.3625 5.5125C0.6875 6.8375 0.3 8.3 0.3 9.85C0.3 11.4 0.6875 12.8625 1.3625 14.1875L4.525 11.7625Z" fill="#FBBC05"/>
      <path d="M10 4.0375C11.775 4.0375 12.9875 4.825 13.675 5.4625L16.4 2.8375C14.7 1.275 12.575 0.3 10 0.3C6.2125 0.3 2.9875 2.425 1.3625 5.5125L4.5125 7.9375C5.375 5.7 7.5 4.0375 10 4.0375Z" fill="#EA4335"/>
    </svg>
  );
};

export default GoogleIcon; 